import { createAction, props } from '@ngrx/store';

import { FastSintMethod, FastSintPhysicalStoreDetail, FastSintStore } from '../models/fast-sint.models';

export const FastSintActions = {
    INIT_FAST_SINT: '[FastSint] INIT_FAST_SINT',
    INIT_FAST_SINT_SUCCESS: '[FastSint] INIT_FAST_SINT_SUCCESS',
    INIT_FAST_SINT_ERROR: '[FastSint] INIT_FAST_SINT_ERROR',
    FAST_SINT_INITIALIZED: '[FastSint] FAST_SINT_INITIALIZED',
    FAST_SINT_DESTROYED: '[FastSint] FAST_SINT_DESTROYED',
    SET_FAST_SINT_STORES: '[FastSint] SET_FAST_SINT_STORES',
    SET_FAST_SINT_SELECTED_STORE: '[FastSint] SET_FAST_SINT_SELECTED_STORE',
    SET_FAST_SINT_SELECTED_STORE_SUCCESS: '[FastSint] SET_FAST_SINT_SELECTED_STORE_SUCCESS',
    SET_FAST_SINT_HOUR: '[FastSint] SET_FAST_SINT_HOUR',
    SET_FAST_SINT_METHOD: '[FastSint] SET_FAST_SINT_METHOD',
    SET_FAST_SINT_SHIPPING_STORE: '[FastSint] SET_FAST_SINT_SHIPPING_STORE',
};

// #region Lifecycle events
export const FastSintInitialized = createAction(FastSintActions.FAST_SINT_INITIALIZED);
export const FastSintDestroyed = createAction(FastSintActions.FAST_SINT_DESTROYED);
// #endregion

export const ExploreFastSintSuccess = createAction(
    FastSintActions.INIT_FAST_SINT_SUCCESS,
    props<{ enabled?: boolean }>()
);

export const ExploreFastSintError = createAction(
    FastSintActions.INIT_FAST_SINT_ERROR,
    props<{ error: any }>()
);

export const SetFastSintStores = createAction(
    FastSintActions.SET_FAST_SINT_STORES,
    props<{ enabled: boolean; stores: FastSintStore[] }>()
);
export const SetFastSintSelectedStore = createAction(
    FastSintActions.SET_FAST_SINT_SELECTED_STORE,
    props<{ store: FastSintPhysicalStoreDetail }>()
);
export const SetFastSintSelectedStoreSuccess = createAction(
    FastSintActions.SET_FAST_SINT_SELECTED_STORE_SUCCESS,
);
export const SetFastSintMethod = createAction(
    FastSintActions.SET_FAST_SINT_METHOD,
    props<{ method: FastSintMethod }>()
);
export const SetFastSintShippingStore = createAction(
    FastSintActions.SET_FAST_SINT_SHIPPING_STORE,
    props<{ store: FastSintPhysicalStoreDetail }>()
);
